import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import ClientDataNavUI from '../../../components/superUser/clientData/ClientDataNavUI'
import ITRProfitAndLossUI from '../../../components/superUser/clientData/ITRProfitAndLossUI'
import ITRBalanceSheetUI from '../../../components/superUser/clientData/ITRBalanceSheetUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ITRSubservientChargesUI from '../../../components/superUser/clientData/ITRSubservientChargesUI'
import ITRChargeValueCalculationUI from '../../../components/superUser/clientData/ITRChargeValueCalculationUI'
import './MCAReportPage.css'

const ITRReportPageUI = ({ context, account, profitAndLossList, balanceSheetList, chargeValueCalculation, toggleEditable, editable, onRefreshClick }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_mca' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!profitAndLossList}
    account={account} page='clientData'
  >
    {
      !profitAndLossList &&
      <SpinnerComponentUI />
    }
    {
      profitAndLossList &&
      <div>
        <ITRReportUI
          context={context}
          onRefreshClick={onRefreshClick}
        />

        {
          account &&
          <ClientDataNavUI account={account} page='itr' />
        }

        <div className='g_flex_h g_flex_left g_flex_wrap nav'>
          <a className='w_tab' href='#itrBalanceSheet'>Balance Sheet</a>
          <a className='w_tab' href='#itrSubCharges'>Subservient Charges</a>
          <a className='w_tab' href='#itrPnL'>Profit and Loss</a>
          <a className='w_tab' href='#itrChargeValue'>Charge value calculation</a>
        </div>

        <ITRBalanceSheetUI balanceSheetList={balanceSheetList} />
        <ITRSubservientChargesUI context={context} account={account} bsList={balanceSheetList} />
        <ITRProfitAndLossUI pnlList={profitAndLossList} />
        <ITRChargeValueCalculationUI chargeValueCalculation={chargeValueCalculation} toggleEditable={toggleEditable} editable={editable} />
      </div>
    }
  </SuperUserAccountPageUI>

const ITRReportUI = ({ context, onRefreshClick }) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Client Data - ITR</b></span>
        </div>
      }
      right={<span />}
    />
  </div>

export default ITRReportPageUI
